import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ProductDetailPage } from './product-detail.page';
import { SharedModule } from '../../shared-module/shared.module';
import { ProductDetailPageRoutingModule } from './product-detail-routing.module';

@NgModule({
  imports: [
    FormsModule,
    IonicModule,
    CommonModule,
    SharedModule,
    ProductDetailPageRoutingModule,
  ],
  declarations: [ProductDetailPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductDetailPageModule {}
